module.exports = __webpack_public_path__ + "media/images/logo/sns/twitter-1cb2dbe4b41cba0867c8ef6740b86fcf.png";